import React from 'react';
import logo from '../Images/logo.jpg' 

import '../Styles/Cover.css';

const Cover = () => {
	return (
		<div id="Cover">
			<div className="logo-container centered">
				<img src={logo} alt="Thrift savanna logo" className="logo"/>
			</div>
			<div className="centered">
				<h1>Thrift Savanna</h1>	
			</div> 

		</div>
	)
}

export default Cover;